var _defs, _g, _g2, _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSettings(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 256,
    height: 256,
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    "aria-label": "Settings gear",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "glow",
    x: "-30%",
    y: "-30%",
    width: "160%",
    height: "160%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "SourceGraphic",
    stdDeviation: 5,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "blur"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "gearMask"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "#000"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,0)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 2,
    width: 18,
    height: 20,
    rx: 6,
    ry: 6,
    transform: "rotate(0 50 50)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 2,
    width: 18,
    height: 20,
    rx: 6,
    ry: 6,
    transform: "rotate(45 50 50)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 2,
    width: 18,
    height: 20,
    rx: 6,
    ry: 6,
    transform: "rotate(90 50 50)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 2,
    width: 18,
    height: 20,
    rx: 6,
    ry: 6,
    transform: "rotate(135 50 50)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 2,
    width: 18,
    height: 20,
    rx: 6,
    ry: 6,
    transform: "rotate(180 50 50)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 2,
    width: 18,
    height: 20,
    rx: 6,
    ry: 6,
    transform: "rotate(225 50 50)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 2,
    width: 18,
    height: 20,
    rx: 6,
    ry: 6,
    transform: "rotate(270 50 50)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 2,
    width: 18,
    height: 20,
    rx: 6,
    ry: 6,
    transform: "rotate(315 50 50)"
  }))), /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 17,
    fill: "#000"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#glow)",
    opacity: 0.85,
    mask: "url(#gearMask)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "#0f6788"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#gearMask)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "#0f6788"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 17,
    fill: "none",
    stroke: "#083b4b",
    strokeOpacity: 0.35,
    strokeWidth: 0.8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50 15            A35 35 0 1 1 49.99 15",
    fill: "none",
    stroke: "#083b4b",
    strokeOpacity: 0.25,
    strokeWidth: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/settings.6f500833c0d007685a712a51c6405dda.svg";
export { ForwardRef as ReactComponent };